module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/35949e8b2d8514ceafbc6f4c1b0da8ca.png";